module.exports = __webpack_public_path__ + "img/main_desc-1.fc10cce7.jpg";